import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@material-ui/core';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';

import { getFormByCurrentLanguage } from 'utils/form-localization/formLocalization';

import { Prices } from '../product-short-info/ProductShortInfo';

import useStyles from './styles';

const ActivitiesList = ({ fields, selectCallback, currency }) => {
  const classes = useStyles();
  const [t, i18n] = useTranslation();

  const selectedLanguage = i18n.language;

  if (!fields.length) return null;

  return (
    <div className={classes.wrapper}>
      {fields.map((field, index) => {
        const item = fields.get(index);
        const form = getFormByCurrentLanguage(
          selectedLanguage,
          item,
          item['Norwegian']
        );
        return (
          <div
            key={index}
            className={classes.item}
            onClick={() => selectCallback(item, index)}
          >
            <div
              className={classes.photo}
              style={{
                backgroundImage: `url(${item.photo})`
              }}
            >
              {''}
              {item.isSelected && (
                <div className={classes.selected}>
                  <CheckCircleOutlineOutlinedIcon
                    className={classes.selectedIcon}
                  />
                </div>
              )}
            </div>
            <div className={classes.info}>
              <div className={classes.titleWrapper}>
                <Typography variant="h2" className={classes.title}>
                  {form.title}
                </Typography>
                <ArrowForwardIosIcon className={classes.icon} />
              </div>
              <div className={classes.prices}>
                <Prices
                  prices={item.prices[item.pricesType]}
                  pricesType={item.pricesType}
                  scheduleType={item.scheduleType}
                  initialSelectedCurrency={currency}
                  isAvailableEmptyPrice={true}
                />
              </div>
              <Typography variant="body1" className={classes.overview}>
                {form.overview}
              </Typography>
              {index !== fields.length - 1 && (
                <div className={classes.divider}>{''}</div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ActivitiesList;
